import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { AxiosError } from 'axios';

import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

import { TOKEN, COMPANY_LOGO } from '../constant';
import { useTimecampService } from '../services/timecamp.service';
import '../App.css';
import { FormCheck } from 'react-bootstrap';

export const Login = (props: { setRoute: (e: string) => void; setCompanyLogo: (logo: string | null) => void }) => {
    const { setRoute, setCompanyLogo } = props;
    const { login, pageVisit } = useTimecampService();

    const [token, setToken] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [isLoading, setLoading] = useState<boolean>(false);
    const [rememberMe, setRememberMe] = useState<boolean>(true);

    const handleTokenInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setError('');
        setToken(event.target.value);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        login({ token })
            .then((response) => {
                Cookies.set(
                    TOKEN,
                    response.token, {
                        expires: rememberMe ? 30: undefined,
                        secure: true,
                });
                if (response.companyLogo) {
                    Cookies.set(
                        COMPANY_LOGO,
                        response.companyLogo, {
                            expires: rememberMe ? 30: undefined,
                            secure: true,
                    });
                    setCompanyLogo(response.companyLogo);
                }
                setRoute('home');
            })
            .catch((err: AxiosError) => {
                if (err.message) {
                    setError(err.message);
                }
                console.error(err);
            }).finally(() => {
                setLoading(false);
            });
    }

    useEffect(()=>{
        pageVisit({ page: 'landing-page' });
    }, []);

    return (<Form className='Login-form' onSubmit={handleFormSubmit}>
        <FloatingLabel
            label="Admin Token"
            className="mb-3"
        >
            <Form.Control required id="token" name='token' type="text" autoComplete="off" placeholder='Enter Token' value={token} onChange={handleTokenInput}
                isInvalid={Boolean(error)} />
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </FloatingLabel>
        <div className="remember-checkbox" >
            <Form.Check
                type={'checkbox'}
                label={`Remember for 30 days ? `}
                id={`inline-checkbox-1`}
                checked={rememberMe}
                onClick={() => setRememberMe((_rememberMe) => !_rememberMe)}
            />
        </div>
        <Button variant="primary" size="lg" type='submit' disabled={isLoading}>
            {isLoading ? <Spinner animation="border" /> : 'Login'}
        </Button>

    </Form>);
};